export enum ReportTypeEnum {
  CUSTOMER_DETAILS = "CUSTOMER_DETAILS",
  ITEMS_SALES = "ITEMS_SALES",
  LOYALTY_TRANSACTIONS = "LOYALTY_TRANSACTIONS",
  ORDER_HISTORY = "ORDER_HISTORY",
  CUSTOMER_RATINGS = "CUSTOMER_RATINGS",
  PAYMENT_LINKS = "PAYMENT_LINKS",
}
